import { memo } from "react";
import { Form } from "react-bootstrap";
import { MappingParams } from "../../lib/map-csv-row-to-imported-investor-entry";
import "./ImportMappingParamsForm.scss";

interface ImportMappingParamsFormProps {
  onUpdate: (params: MappingParams) => void;
  value: MappingParams;
}

const ImportMappingParamsForm: React.FC<ImportMappingParamsFormProps> = ({
  onUpdate,
  value: importMappingParams,
}) => {
  return (
    <Form className="mapping-params-form">
      <Form.Group>
        <Form.Control
          type="text"
          placeholder="Enter source name"
          value={importMappingParams.sourceName}
          onChange={(e) =>
            onUpdate({
              ...importMappingParams,
              sourceName: e.target.value,
            })
          }
          required
        />
      </Form.Group>
      <Form.Group>
        <Form.Control
          type="text"
          placeholder="Enter source URL"
          value={importMappingParams.sourceUrl}
          onChange={(e) =>
            onUpdate({
              ...importMappingParams,
              sourceUrl: e.target.value,
            })
          }
        />
      </Form.Group>
    </Form>
  );
};

export default memo(ImportMappingParamsForm);
